










import Vue, { PropType } from "vue";

export default Vue.extend({
  name: "ShowMoreView",
  components: {},
  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCollapsed: !this.isExpanded as boolean,
    };
  },
  created() {},
  mounted() {},
  methods: {
    toggleExpandable() {
      this.isCollapsed = !this.isCollapsed;

      this.$emit("isCollapsed", this.isCollapsed);
    },

    //not in use
    /* readScrollHeight() {
      this.scrollHeight = this.isCollapsed ? 0 : (this.$refs.expandableContent as any).scrollHeight;
    }, */
  },
  watch: {
    isExpanded() {},
  },
  computed: {},
});
